/**
 * Zehra Gems luxury PDP - mobile sticky Add to Cart bar.
 *
 * Behaviour:
 *  - Shows the sticky bar only when the real, in-page Add to Cart button
 *    has scrolled out of the viewport (IntersectionObserver - no scroll
 *    event listeners, no layout thrashing).
 *  - Clicking the sticky bar's button clicks the REAL Add to Cart button,
 *    so all existing cart logic (product-form.js, cart drawer, error
 *    handling) runs exactly as it does today. Nothing is duplicated.
 *  - CSS media query already restricts the bar to mobile widths; this
 *    script only handles show/hide + the click delegation.
 *  - Defensive: does nothing if the target elements aren't present, and
 *    does nothing on browsers without IntersectionObserver support.
 */
document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('.zg-mobile-sticky-bar[data-target-section]');

  bars.forEach(function (bar) {
    var sectionId = bar.getAttribute('data-target-section');
    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);

    if (!realButton) return;

    var ctaButton = bar.querySelector('[data-zg-sticky-add-to-cart]');
    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        realButton.click();
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
      observer.observe(realButton);
    }
  });
});
